import { render } from "./CategoryBrowse.vue?vue&type=template&id=7c615bd2&scoped=true"
import script from "./CategoryBrowse.vue?vue&type=script&lang=js"
export * from "./CategoryBrowse.vue?vue&type=script&lang=js"

import "./CategoryBrowse.vue?vue&type=style&index=0&id=7c615bd2&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c615bd2"]])

export default __exports__